import { Button } from "antd";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

const ChangePasswordConfirm = () => {
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const redirectToLogin = () => {
    history.push("/login");
  };

  return (
    <div className="forgot-text">
      <h1 className="forgot-title">
        The password has been{" "}
        <span className="forgot-blue-text">successfully</span> changed.
      </h1>
      <h3 className="forgot-desc">
        <span className="forgot-gray-text">
          use your new password to log in.
        </span>
      </h3>
      <Button onClick={redirectToLogin} type="primary">
        Login
      </Button>
    </div>
  );
};

ChangePasswordConfirm.displayName = "Confirmation";

export default ChangePasswordConfirm;
